export class ValueAdditionIdModel{
    valueAdditionIdName: string;
    valueAdditionCode: string;

    constructor( valueAdditionIdName: string, valueAdditionCode: string) {
       this.valueAdditionIdName=valueAdditionIdName;
       this.valueAdditionCode=valueAdditionCode;
    }
}